import { getDynamicSemanticToken } from '../../../DesignSystem';
import { getDefaultZoomUI } from '../../../ThemeProvider';
export function getDynamicThemeToken(theme) {
    const semantic = getDynamicSemanticToken(theme);
    const { typography } = theme?.zoomUI ?? getDefaultZoomUI();
    return {
        fontSize: 12,
        closeIconSize: 10,
        lineHeight: '16px',
        fontFamily: typography.fontFamily,
        borderRadius: 5,
        gap: 4,
        color: {
            default: semantic.text.stronger.neutral,
            disabled: semantic.state.disable,
            error: semantic.text.error,
            errorDisabled: semantic.state.subtle.error.disable,
        },
        background: {
            default: semantic.fill.subtler.neutral,
            hover: semantic.state.subtle.neutral.hover,
            active: semantic.state.subtle.neutral.press,
            disabled: semantic.fill.subtler.neutral,
        },
        margin: {
            deleteIcon: '0',
        },
        padding: {
            root: '2px 8px',
            deleteIcon: '0',
        },
        outline: `2px solid ${semantic.border.primary}`,
        boxShadow: {
            error: `inset 0 0 0 1px ${semantic.border.error}`,
            errorDisabled: `inset 0 0 0 1px ${semantic.state.subtle.error.disable}`,
        },
    };
}
